module.exports = __webpack_public_path__ + "static/img/img-features-feature-6-parents_ja.0b8ee7c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/img-features-feature-6-parents_ja.png
// module id = 6F8P
// module chunks = 18